interface BooleanFilterProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  yesLabel?: string;
  noLabel?: string;
}

export function BooleanFilter({
  value,
  onChange,
  yesLabel = 'Yes',
  noLabel = 'No',
}: BooleanFilterProps) {
  return (
    <div className="flex gap-1">
      <button
        onClick={() => onChange(value === null ? null : null)}
        className={`flex-1 px-3 py-2 text-sm rounded-lg transition-colors ${
          value === null
            ? 'bg-forest-700 text-white'
            : 'bg-sage-100 text-sage-600 hover:bg-sage-200'
        }`}
      >
        All
      </button>
      <button
        onClick={() => onChange(true)}
        className={`flex-1 px-3 py-2 text-sm rounded-lg transition-colors ${
          value === true
            ? 'bg-green-600 text-white'
            : 'bg-sage-100 text-sage-600 hover:bg-sage-200'
        }`}
      >
        {yesLabel}
      </button>
      <button
        onClick={() => onChange(false)}
        className={`flex-1 px-3 py-2 text-sm rounded-lg transition-colors ${
          value === false
            ? 'bg-red-600 text-white'
            : 'bg-sage-100 text-sage-600 hover:bg-sage-200'
        }`}
      >
        {noLabel}
      </button>
    </div>
  );
}
